export const makeDict = (): any => Object.create(null);
